<div class="multiselect-container">
  @if (!multiSelect) {
    <div>
      <mat-select
        [(value)]="LLMsSelected"
        (selectionChange)="LLMSelectionChange($event)"
        panelClass="with-action-icons-right"
        class="attachment-dropdown"
        matTooltip="{{LLMsListTooltip}}" matTooltipShowDelay="500">
        <mat-select-trigger>
          <ng-container>{{ LLMsSelected }}</ng-container>
        </mat-select-trigger>
        @for (LLM of LLMList; track $index) {
          <mat-option [value]="LLM.name"
                      [matTooltip]="LLM.description"
                      matTooltipShowDelay="500">
            <span class="icon-right">
              <span>{{ LLM.name }}</span>
            </span>
          </mat-option>
        }
      </mat-select>
    </div>
  }
  @if (multiSelect) {
    <div>
      @if (LLMsSelected.length === 0) {
        <span
        class="multi-select-placeholder">LLMs...</span>
      }
      <mat-select
        [(value)]="LLMsSelected"
        (selectionChange)="LLMSelectionChange($event)"
        multiple panelClass="with-action-icons-right"
        class="attachment-dropdown"
        matTooltip="{{LLMsListTooltip}}" matTooltipShowDelay="500">
        <mat-select-trigger>
          @if (LLMsSelected.length > 0) {
            {{ (LLMsSelected.length > 1 ? (LLMsSelected[0] + '...') : LLMsSelected[0]!) }}
          }
          @if (LLMsSelected.length > 1) {
            <span>
              (+{{ (LLMsSelected.length) - 1 }} more)
            </span>
          }
        </mat-select-trigger>
        @for (LLM of LLMList; track $index) {
          <mat-option [value]="LLM.name"
                      [matTooltip]="LLM.description"
                      matTooltipShowDelay="500">
            <span class="icon-right">
              <span>{{ LLM.name }}</span>
              <mat-icon fontIcon="emoji_events" class="mark-default" tabindex="0"
                matTooltip="Mark as the default LLM for prompts"
                matTooltipShowDelay="500"
                [ngClass]="{'active': LLM.name === defaultLLM }"
                (click)="updateDefaultLLM(LLM, $event)"
                (keydown.enter)="updateDefaultLLM(LLM, $event)"
                (keydown.space)="updateDefaultLLM(LLM, $event)"></mat-icon>
            </span>
          </mat-option>
        }
      </mat-select>
    </div>
  }
</div>
